import { ThemeToggle } from "./themeToggle.js";
import { TypeWriter } from "./typewriter.js";
import { CountUp } from "./countUp.js";
const toggle = new ThemeToggle("themeToggle");
const typewriter = new TypeWriter("siteHeader");
const countUp = new CountUp("postCount", 0, null, 30, 80, false);
